import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { configureApi } from "@chess/shared";
import { ENV } from "@/util/env";
import { App } from "./App";

configureApi({ baseUrl: ENV.API_BASE_URL });

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
